<template>
  <div class="v-stack h-stretch gap-3">
    <div class="h-stack h-space-between">
      <a class="heading-title-2" style="align-self: center">Expenses</a>
      <button class="add" @click="$router.push('/finance/expenses/add/gear')">
        Add Expense
      </button>
    </div>
    <div class="card light mn">
      <div class="content h-stretch">
        <div class="v-stack h-stretch gap-3" v-if="data">
          <div class="pane-horizontal gap-3">
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <a>One Time & Reccuring</a>
              <div
                class="pane-horizontal gap-3"
                v-for="(value, category) in categories"
                :key="category"
              >
                <div class="text-right">{{ category }}:</div>
                <div class="text-left">
                  {{ format.currency(value) }}
                  Kč
                </div>
              </div>
            </div>
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <a>Other</a>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Gear:</div>
                <div class="text-left">{{ format.currency(data.gear) }} kč</div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Crew:</div>
                <div class="text-left">{{ format.currency(data.crew) }} kč</div>
              </div>
            </div>
          </div>
          <div class="v-stack h-stretch v-start gap-3 card py-5">
            <a>Sum</a>
            <div class="pane-horizontal gap-3">
              <div class="text-right">OneTime & Reccuring:</div>
              <div class="text-left">
                {{ format.currency(data.oneTimeAndRecurringTotal) }}
                kč
              </div>
            </div>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Other:</div>
              <div class="text-left">
                {{ format.currency(data.otherTotal) }} kč
              </div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-3" style="font-weight: bold">
              <div class="text-right">Total:</div>
              <div class="text-left">
                {{ format.currency(data.total) }}
                kč
              </div>
            </div>
          </div>
        </div>
        <div v-else><span class="loader"></span></div>
      </div>
    </div>
    <template v-if="data">
      <div class="h-stack gap-3 h-start v-center">
        <a class="heading-title-2">One Time Expenses</a>
        <label>Category:</label>
        <select v-model="categoryFilterOneTime">
          <option value="">all</option>
          <option
            v-for="(value, category) in data.oneTime.categories"
            :key="category"
            :value="category"
          >
            {{ category }}
          </option>
        </select>
      </div>
      <div class="card light mn pn">
        <div class="card pa-5">
          <div class="v-stack h-stretch gap-3">
            <div
              class="pane-horizontal gap-3"
              v-for="(value, category) in data.oneTime.categories"
              :key="category"
            >
              <div class="text-right">{{ category }}:</div>
              <div class="text-left">
                {{ format.currency(value) }}
                Kč
              </div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-2">
              <div class="text-right">Sum:</div>
              <div class="text-left">
                {{ format.currency(data.oneTime.total) }} Kč
              </div>
            </div>
          </div>
        </div>
      </div>
      <Table
        v-on:rowSelected="$router.push('/finance/expenses/edit/' + $event._id)"
        :items="filteredOneTimeExpenses"
        :loading="loadingOneTimeExpenses"
        :defaultColumn="0"
        :limit="10"
        :pageable="true"
        :height="360"
        :columns="[
          {
            name: 'Date',
            sort: 'date',
            path: ['date'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Category',
            sort: 'alphabet',
            path: ['category'],
          },
          {
            name: 'Title',
            sort: 'alphabet',
            path: ['name'],
          },
          {
            name: 'Amount',
            sort: 'numeric',
            path: ['amount'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Store',
            sort: 'alphabet',
            path: ['store'],
          },
          {
            name: 'Description',
            sort: 'alphabet',
            path: ['description'],
          },
        ]"
      ></Table>
      <div class="h-stack gap-3 v-center h-start">
        <a class="heading-title-2">Reccuring Expenses</a>
        <label>Category:</label>
        <select v-model="categoryFilterReccuring">
          <option value="">all</option>
          <option
            v-for="(value, category) in data.recurring.categories"
            :key="category"
            :value="category"
          >
            {{ category }}
          </option>
        </select>
      </div>
      <div class="card light mn pn">
        <div class="card pa-5">
          <div class="v-stack h-stretch gap-3">
            <div
              class="pane-horizontal gap-3"
              v-for="(value, category) in data.recurring.categories"
              :key="category"
            >
              <div class="text-right">{{ category }}:</div>
              <div class="text-left">
                {{ format.currency(value) }}
                Kč
              </div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-2">
              <div class="text-right">Sum:</div>
              <div class="text-left">
                {{ format.currency(data.recurring.total) }} Kč
              </div>
            </div>
          </div>
        </div>
      </div>
      <Table
        v-on:rowSelected="
          $router.push('/finance/expenses/edit/' + $event.reference)
        "
        :items="filteredRecurringExpenses"
        :defaultColumn="0"
        :limit="10"
        :height="360"
        :pageable="true"
        :columns="[
          {
            name: 'Date',
            sort: 'date',
            path: ['date'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Category',
            sort: 'alphabet',
            path: ['category'],
          },
          {
            name: 'Title',
            sort: 'alphabet',
            path: ['name'],
          },
          {
            name: 'Store',
            sort: 'alphabet',
            path: ['store'],
          },
          {
            name: 'End Date',
            sort: 'date',
            path: ['reccuringEndDate'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Amount',
            sort: 'numeric',
            path: ['amount'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Description',
            sort: 'alphabet',
            path: ['description'],
          },
        ]"
      ></Table>
      <a class="heading-title-1">Gear</a>
      <div class="card light mn pn">
        <div class="card pa-5">
          <div class="pane-horizontal gap-3">
            <div class="text-right">Sum:</div>
            <div class="text-left">{{ format.currency(data.gear) }} Kč</div>
          </div>
        </div>
      </div>
      <a class="heading-title-2">Pricelist Gear</a>
      <Table
        v-on:rowSelected="
          $router.push('/pricelist/item/detail/' + $event.item._id)
        "
        :items="gearInPricelist"
        :loading="loadingGearExpenses"
        :defaultColumn="0"
        :limit="10"
        :height="360"
        :pageable="true"
        :columns="[
          {
            name: 'Date',
            sort: 'date',
            path: ['dateOfPurchase'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Serial Number',
            sort: 'alphabet',
            path: ['serialNumber'],
          },
          {
            name: 'Store Description',
            sort: 'alphabet',
            path: ['storeDescription'],
          },
          {
            name: 'Cost',
            sort: 'numeric',
            path: ['value'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Description',
            sort: 'alphabet',
            path: ['description'],
          },
        ]"
      ></Table>
      <a class="heading-title-2">One Time Gear Expenses</a>
      <Table
        v-on:rowSelected="$router.push('/finance/expenses/edit/' + $event._id)"
        :items="oneTimeGearExpenses"
        :loading="loadingGearExpenses"
        :defaultColumn="0"
        :limit="10"
        :height="360"
        :pageable="true"
        :columns="[
          {
            name: 'Date',
            sort: 'date',
            path: ['date'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Title',
            sort: 'alphabet',
            path: ['name'],
          },
          {
            name: 'Store',
            sort: 'alphabet',
            path: ['store'],
          },
          {
            name: 'Amount',
            sort: 'numeric',
            path: ['amount'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Description',
            sort: 'alphabet',
            path: ['description'],
          },
        ]"
      ></Table>
      <a class="heading-title-2">Recurring Gear Expenses</a>
      <Table
        v-on:rowSelected="
          $router.push('/finance/expenses/edit/' + $event.reference)
        "
        :items="recurringGearExpenses"
        :loading="loadingGearExpenses"
        :defaultColumn="0"
        :limit="10"
        :height="360"
        :pageable="true"
        :columns="[
          {
            name: 'Date',
            sort: 'date',
            path: ['date'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Title',
            sort: 'alphabet',
            path: ['name'],
          },
          {
            name: 'Store',
            sort: 'alphabet',
            path: ['store'],
          },
          {
            name: 'End Date',
            sort: 'date',
            path: ['reccuringEndDate'],
            formatType: 'date',
            format: 'DD.MM.YYYY',
          },
          {
            name: 'Amount',
            sort: 'numeric',
            path: ['amount'],
            format: 'czk',
            formatType: 'currency',
          },
          {
            name: 'Description',
            sort: 'alphabet',
            path: ['description'],
          },
        ]"
      ></Table>
      <a class="heading-title-1">Crew</a>
      <div class="card light mn pn">
        <div class="card pa-5">
          <div class="pane-horizontal gap-3">
            <div class="text-right">Sum:</div>
            <div class="text-left">{{ format.currency(data.crew) }} Kč</div>
          </div>
        </div>
      </div>
      <Hours
        :userFilter="'all'"
        :period="period"
        :year="year"
        :month="month"
        :startDate="startDate"
        :endDate="endDate"
      ></Hours>
    </template>
  </div>
</template>

<script>
import Table from "@/components/Table.vue";
import Hours from "@/components/Hours.vue";
import moment from "moment";
import { mapActions } from "vuex";
import utils from "@/utils.js";

export default {
  data() {
    return {
      format: utils.format,
      data: null,
      oneTimeExpenses: [],
      recurringExpenses: [],
      gearInPricelist: [],
      oneTimeGearExpenses: [],
      recurringGearExpenses: [],
      categoryFilterOneTime: "",
      categoryFilterReccuring: "",
      loadingOneTimeExpenses: true,
      loadingRecurringExpenses: true,
      loadingGearExpenses: true,
    };
  },
  props: {
    period: {
      type: String,
      default: () => "",
    },
    year: {
      type: String,
      default: () => "",
    },
    month: {
      type: Number,
      default: () => "",
    },
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    categories() {
      const categories = {
        ...this.data.oneTime.categories,
      };

      for (const [key, value] of Object.entries(
        this.data.recurring.categories
      )) {
        categories[key] = (categories[key] ?? 0) + value;
      }
      return categories;
    },
    filteredOneTimeExpenses() {
      if (this.categoryFilterOneTime != "") {
        return this.oneTimeExpenses.filter(
          (expense) => expense.category == this.categoryFilterOneTime
        );
      }
      return this.oneTimeExpenses;
    },
    filteredRecurringExpenses() {
      if (this.categoryFilterReccuring != "") {
        return this.recurringExpenses.filter(
          (expense) => expense.category == this.categoryFilterReccuring
        );
      }
      return this.recurringExpenses;
    },
  },
  watch: {
    period() {
      this.refresh();
    },
    year() {
      this.refresh();
    },
    month() {
      this.refresh();
    },
    startDate() {
      this.refresh();
    },
    endDate() {
      this.refresh();
    },
  },
  components: {
    Table,
    Hours,
  },
  methods: {
    ...mapActions([
      "getOverviewExpenses",
      "getFinanceOneTimeExpenses",
      "getFinanceRecurringExpenses",
      "getFinanceGearExpenses",
    ]),
    refresh() {
      this.loadingOneTimeExpenses = true;
      this.loadingRecurringExpenses = true;
      this.loadingGearExpenses = true;

      this.getOverviewExpenses({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.getFinanceOneTimeExpenses({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.oneTimeExpenses = data;
          this.loadingOneTimeExpenses = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingOneTimeExpenses = false;
        });

      this.getFinanceRecurringExpenses({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.recurringExpenses = data;
          this.loadingRecurringExpenses = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingRecurringExpenses = false;
        });

      this.getFinanceGearExpenses({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.gearInPricelist = data.gearInPricelist;
          this.oneTimeGearExpenses = data.oneTimeGearExpenses;
          this.recurringGearExpenses = data.recurringGearExpenses;
          this.loadingGearExpenses = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingGearExpenses = false;
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.h-stack div {
  align-self: center;
}

.h-stack label {
  align-self: center;
}

.h-stack select {
  align-self: center;
  width: 160px;
}

a {
  align-self: center;
  padding-top: 0 !important;
}
</style>
